import '../styles/app.css'

import './core'

// history.scrollRestoration = "manual"

// components
import './components/welcome'
import './components/some-discoveries'
import './components/slider'
import './components/marquee-logos'
import './components/pannel-navigation'
import './components/pannel-filters'
import './components/accordions'
import './components/pannel'
import './components/alert'
import './components/load-more'

//// custom select
const init_custom_select = () => {
    document.querySelectorAll( 'select:not(.custom)' ).forEach( select => {
        let container = document.createElement( 'div' )
            container.classList.add( 'custom-select' )
        
        select.after( container )
        container.appendChild( select )
        select.classList.add( 'custom' )        
    } )
}

document.addEventListener( 'ContentLoaded', init_custom_select )
document.addEventListener( 'NewContentLoaded', init_custom_select )
////


//// custom headroom
// calculer
// voir si il y a une animation
// recalculer à la fin de l'animation

let state = 'unpinned'
let lastState = ''
let direction = 'down'
let lastDirection = ''
let lastScrollTop = 0

const run_headroom = () => {
    const scroll = window.scrollY
    const limit = window.innerHeight

    if ( document.documentElement.classList.contains( `headroom--hidden` ) ) {
        return
    }

    // Scroll vers le bas
    if ( scroll > lastScrollTop && scroll > limit ) {
        state = 'pinned'
    }
    // Scroll vers le haut
    else if ( scroll < lastScrollTop && scroll < limit ) {
        state = 'unpinned'
    }

    if ( lastState !== state ) {
        document.documentElement.classList.remove( `headroom--${lastState}` )
        document.documentElement.classList.add( `headroom--${state}` )
    }
    
    // Scroll vers le bas
    if ( scroll > lastScrollTop ) {
        direction = 'down'
    }
    // Scroll vers le haut
    else if ( scroll < lastScrollTop) {
        direction = 'up'
    }

    if ( lastDirection !== direction ) {
        document.documentElement.classList.remove( `headroom--${lastDirection}` )
        document.documentElement.classList.add( `headroom--${direction}` )
    }
    
    if ( state === 'unpinned' && direction === 'up' && scroll < limit && scroll > (limit - 100) ) {
        document.documentElement.classList.add( `headroom--hidden` )
        setTimeout( () => document.documentElement.classList.remove( `headroom--hidden` ), data?.transitions?.default?.duration + 10 )
    }

    lastScrollTop = scroll
    lastState = state
    lastDirection = direction
}

window.addEventListener( 'scroll', run_headroom )
////


// Séparer les fonctionnalités en modules
document.addEventListener( 'ShowElements', data => {
    if (data?.detail?.elements) {
        data.detail.elements.forEach( element => {
            if (element.getAttribute('animate-words') !== null) {
                document.dispatchEvent(new CustomEvent('AnimateWords', { detail: { elements: [element] } }))
            }
        } )
    }
} )

document.addEventListener( 'ShowElements', data => {
    if (data?.detail?.elements) {
        data.detail.elements.forEach( element => {
            if (element.getAttribute('animate-lines') !== null) {
                document.dispatchEvent(new CustomEvent('AnimateLines', { detail: { elements: [element] } }))
            }
        } )
    }
} )